import { QueryClient } from '@tanstack/react-query';

export const rootQueryClient = new QueryClient({});

export const clearRootQueryCache = () => {
  rootQueryClient.clear();
};

export const invalidateRootQuery = (queryKey: unknown[]) => {
  rootQueryClient.invalidateQueries(queryKey);
};
